import { userApis } from '@apis/dashboard/userApis';
import { createUseQuery } from '@hooks/createUseQuery';
import { DashboardUsersQuery } from '@models/User';

export const useUserList = createUseQuery(
  (query: DashboardUsersQuery) => [`/dashboard/user/`, query],
  (query) => () =>
    userApis
      .get('/dashboard/user/', {
        query,
      })
      .then((r) => r[200]!),
);
